export enum MetadataMode {
  // TODO: add DRAFT mode
  FILE = "file",
  GENERATED = "generated",
}

export enum MetadataStatus {
  PENDING = "pending",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  FAILED = "failed",
}
